module.exports = __webpack_public_path__ + "img/How_Much_Does_an_eCommerce_Website_Cost.5c780a17.png";